// @flow

import { connect } from "react-redux";

import Header from "src/components/chatroom/Dialog/Header";
import { getRelated, closeConversationModal } from "src/actions/chatroom";
import { getChatRoom } from "src/reducers";
import type { AppState } from "src/types";

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  room: getChatRoom(app, props.roomId),
  error: app.error.chatroomAttr
});

export default connect(mapStateToProps, { getRelated, closeConversationModal })(
  Header
);
